import React, { createContext, useContext, useState, useCallback } from 'react';

const STORAGE_KEY = 'lastSpaceId';

const SpaceContext = createContext();

const getStoredSpaceId = () => localStorage.getItem(STORAGE_KEY);

const storeSpaceId = (id) => {
  if (id) {
    localStorage.setItem(STORAGE_KEY, id);
  } else {
    localStorage.removeItem(STORAGE_KEY);
  }
};

export const SpaceProvider = ({ children }) => {
  const [currentSpaceId, setCurrentSpaceId] = useState(getStoredSpaceId);

  const selectSpace = useCallback((id) => {
    storeSpaceId(id);
    setCurrentSpaceId(id);
  }, []);

  const clearSpace = useCallback(() => {
    storeSpaceId(null);
    setCurrentSpaceId(null);
  }, []);

  return (
    <SpaceContext.Provider value={{ currentSpaceId, selectSpace, clearSpace }}>
      {children}
    </SpaceContext.Provider>
  );
};

export const useSpace = () => useContext(SpaceContext);

const clearStoredSpaceId = () => storeSpaceId(null);

export { getStoredSpaceId, clearStoredSpaceId };
